import Show from '@/components/Show';
import useGeneratorStore, { R3imagineStatusType } from '@/state/generator-store';
import React from 'react';
import ConditionConfirm from './ConditionConfirm';
import FileUploadCard from './FileUploadCard';
import R3AudioRecorder from './R3AudioRecorder';
import MusicUploadPreview from './MusicUploadPreview';

interface R3ImageAreaProps {
  disabled: boolean;
  hide?: () => void;
}

const R3ImageArea: React.FC<R3ImageAreaProps> = ({ disabled, hide }) => {
  const { r3ImageStatus: status } = useGeneratorStore();

  const shouldShowUploadCard = status === R3imagineStatusType.WaitingUpload || status === R3imagineStatusType.UploadLoading;

  const shouldShowAudioRecorder = status === R3imagineStatusType.WaitingUpload || status === R3imagineStatusType.WaitingAgree;

  const disabledClass = disabled ? 'opacity-50 pointer-events-none' : '';

  return (
    <div className="rounded-lg w-full flex-1 max-w-[500px] lg:col-span-2" style={{ cursor: disabled ? 'not-allowed' : 'auto' }}>
      <Show when={status === R3imagineStatusType.WaitingAgree}>
        <ConditionConfirm disabled={disabled} hide={hide} />
      </Show>

      <Show when={status !== R3imagineStatusType.WaitingAgree}>
        <div className={`bg-[#191A1B] rounded-md p-1 ${disabledClass}`}>
          <div className={disabledClass}>
            <Show when={shouldShowUploadCard}>
              <FileUploadCard disabled={disabled} hide={hide} />
            </Show>
            <Show when={status === R3imagineStatusType.WaitingGenerate}>
              <MusicUploadPreview hide={hide} />
            </Show>
          </div>
          <Show when={shouldShowAudioRecorder}>
            <R3AudioRecorder disabled={disabled} />
          </Show>
        </div>
      </Show>
    </div>
  );
};

export default R3ImageArea;
